/* =========================================================================
   HOLY FOREST — ZUSAETZE IN DER WARENKORB-SCHUBLADE
   Ausgelagert aus holyforest-premium.js, damit die Schublade einen eigenen
   Besitzer hat — dieselbe Buchfuehrung wie bei den Stylesheets.

   Portiert aus dem Figma-Rahmen 32:476: Anzahl als Pille, Versandband,
   Zeile "Versandkosten", Vertrauenszeile unter dem Kaufknopf.

   26.08.2026 — RABATTVORHERSAGE. Der Shop zieht ab zwei Artikeln 15 % ab,
   sagte das in der Schublade aber nie.
   27.08.2026 — VORSCHLAG. Die Vorhersage sagte, dass ein Artikel fehlt, bot
   aber keinen an. Jetzt steht darunter ein konkretes Praeparat mit einem
   Knopf. Die Kandidaten kommen aus snippets/hf-vorschlag.liquid, also aus
   echten Produktdaten — kein erfundener Titel, kein geschaetzter Preis.
   Vorgeschlagen wird nur, was NICHT schon im Warenkorb liegt, und nur
   solange der Rabatt noch nicht greift. Ab zwei Artikeln verschwindet der
   Vorschlag: dann ist die Aufgabe erledigt, und weiter zu draengen waere
   Verkaufsdruck statt Hilfe.

   WAS DIE RABATTZEILE BEWUSST NICHT TUT: den bereits abgezogenen Rabatt
   melden. Das macht Taste selbst in .discounts, mit Betrag und Bezeichnung
   direkt aus dem Warenkorb. Beides zu zeigen hiesse dieselbe Aussage zweimal.

   Wichtig, am DOM nachgesehen statt vermutet: der Kaufknopf liegt NICHT in
   .cart-drawer__footer, sondern in .cart__ctas innerhalb von .drawer__footer.
   Ein append an den Fuss landet deshalb ueber dem Knopf.

   FEHLER IN TASTE, hier abgefangen (hfFixLeerKlasse): cart-drawer.js liest
   beim Oeffnen this.classList.contains('is-empty'), renderContents() nimmt
   die Klasse aber nur vom INNEREN .drawer__inner. Beim ersten Artikel aus
   leerem Warenkorb ist der Fokus-Container darum null und
   getFocusableElements wirft.
   ========================================================================= */

/* ---- Die drei Zahlen, die zu Shopify passen MUESSEN ----------------------
   Versandprofil (deliveryProfiles, 25.08.2026): AT 5,90 € / DE 9,90 €, beide
   ab 100 € frei; uebriges Europa 16,90 € ab 149 € frei; International
   24,90 € ohne Grenze. Hier steht die AT/DE-Schwelle, weil das Band nur
   diese beiden nennt.
   Automatikrabatt (automaticDiscountNodes, 26.08.2026): "2 Flaschen − 15 %",
   aktiv, ohne Enddatum, ab 2 Artikeln.
   Aendert sich eines von beidem, MUSS es hier mit — dieselben Zahlen stehen
   als Einstellung in hf-buendel und in snippets/hf-rechner.liquid. */
const HF_FREE_SHIPPING_CENTS = 10000;
const HF_RABATT_AB = 2;
const HF_RABATT_PROZENT = 15;

const hfMoney = (cents) =>
  typeof window.hfGeld === 'function'
    ? window.hfGeld(cents)
    : new Intl.NumberFormat('de-AT', { style: 'currency', currency: 'EUR' }).format(cents / 100);

let hfCartBusy = false;
let hfCartWieder = false;
let hfCartTimer;
let hfKandidaten = null;

const hfLiesKandidaten = () => {
  if (hfKandidaten !== null) return hfKandidaten;
  const el = document.getElementById('hf-vorschlaege');
  try { hfKandidaten = el ? JSON.parse(el.textContent) : []; } catch (e) { hfKandidaten = []; }
  return hfKandidaten;
};

/* Muss SOFORT laufen, nicht entprellt: Taste liest die Klasse beim
   transitionend des Oeffnens, also wenige Millisekunden nach dem Austausch. */
const hfFixLeerKlasse = () => {
  document.querySelectorAll('cart-drawer').forEach((el) => {
    el.classList.toggle('is-empty', !el.querySelector('.cart-item'));
  });
};

const hfCartHeading = (count) => {
  document.querySelectorAll('.drawer__heading').forEach((heading) => {
    let pill = heading.querySelector('.hf-cart-count');
    if (!count) {
      if (pill) pill.remove();
      return;
    }
    if (!pill) {
      pill = document.createElement('span');
      pill.className = 'hf-cart-count';
      heading.append(pill);
    }
    pill.textContent = String(count);
  });
};

/* Nur die Vorhersage. Liegt der Rabatt an, uebernimmt Tastes .discounts. */
const hfRabatt = (zeile, cart) => {
  if (!zeile) return;
  zeile.textContent = '';

  const fehlt = HF_RABATT_AB - cart.item_count;
  if (cart.total_discount > 0 || cart.item_count < 1 || fehlt < 1) {
    zeile.hidden = true;
    return;
  }

  const marke = document.createElement('b');
  marke.textContent = fehlt === 1 ? 'ein Artikel' : fehlt + ' Artikel';
  zeile.append(
    document.createTextNode('Noch '),
    marke,
    document.createTextNode(' bis −' + HF_RABATT_PROZENT + ' % auf den ganzen Warenkorb.')
  );
  zeile.hidden = false;
};

const hfVorschlag = (kasten, cart) => {
  if (!kasten) return;

  const fehlt = HF_RABATT_AB - cart.item_count;
  if (cart.total_discount > 0 || cart.item_count < 1 || fehlt < 1) {
    kasten.hidden = true;
    return;
  }

  const drin = (cart.items || []).map((i) => i.product_id);
  const treffer = hfLiesKandidaten().find((k) => drin.indexOf(k.produkt) === -1);
  if (!treffer) {
    kasten.hidden = true;
    return;
  }

  const bild = kasten.querySelector('.hf-tipp__bild');
  if (treffer.bild) {
    bild.src = treffer.bild;
    bild.hidden = false;
  } else {
    bild.hidden = true;
  }
  bild.alt = '';

  kasten.querySelector('.hf-tipp__name').textContent = treffer.titel;
  kasten.querySelector('.hf-tipp__form').textContent = treffer.form || '';
  kasten.querySelector('.hf-tipp__preis').textContent = hfMoney(treffer.preis);

  const knopf = kasten.querySelector('.hf-tipp__add');
  knopf.setAttribute('data-id', String(treffer.variante));
  knopf.disabled = false;
  kasten.hidden = false;
};

const hfRenderCart = async () => {
  const targets = [...document.querySelectorAll('.cart-drawer__footer, .cart__footer')];
  if (!targets.length) return;

  /* WETTLAUF, gefunden am 27.08.2026: vorher stand hier nur ein return,
     wenn schon ein Durchgang lief. Jede Aenderung, die WAEHREND des
     laufenden fetch eintraf, war damit verloren — und genau das passiert
     beim Hinzufuegen aus der Schublade, weil Taste den Fuss austauscht,
     waehrend cart.js noch unterwegs ist. Sichtbar wurde es daran, dass die
     Vorschlagszeile nach dem ersten Artikel manchmal gar nicht erschien.
     Jetzt wird der verpasste Durchgang gemerkt und nachgeholt. */
  if (hfCartBusy) {
    hfCartWieder = true;
    return;
  }

  hfCartBusy = true;
  try {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    const response = await fetch(`${root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();

    hfCartHeading(cart.item_count);

    targets.forEach((target) => {
      const wurzel = target.closest('cart-drawer, #main-cart-footer, .drawer__inner') || document;
      let kopf = target.querySelector('.hf-cart-add:not(.hf-cart-add--foot)');
      let fuss = wurzel.querySelector('.hf-cart-add--foot');

      if (!cart.item_count) {
        if (kopf) kopf.remove();
        if (fuss) fuss.remove();
        return;
      }

      if (!kopf) {
        kopf = document.createElement('div');
        kopf.className = 'hf-cart-add';
        kopf.innerHTML =
          '<div class="hf-shipping">' +
          '<p class="hf-shipping__text"></p>' +
          '<div class="hf-shipping__track"><span class="hf-shipping__fill"></span></div>' +
          '</div>' +
          '<p class="hf-rabatt" hidden></p>' +
          '<div class="hf-tipp" hidden>' +
          '<img class="hf-tipp__bild" alt="" width="48" height="48">' +
          '<span class="hf-tipp__text">' +
          '<span class="hf-tipp__name"></span>' +
          '<span class="hf-tipp__form"></span>' +
          '</span>' +
          '<span class="hf-tipp__preis"></span>' +
          '<button type="button" class="hf-tipp__add">Hinzufügen</button>' +
          '</div>' +
          '<div class="hf-cart-add__row"><span>Versandkosten</span>' +
          '<span class="hf-cart-add__wert"></span></div>';
        target.prepend(kopf);
      }

      if (!fuss) {
        fuss = document.createElement('div');
        fuss.className = 'hf-cart-add hf-cart-add--foot';
        fuss.innerHTML =
          '<p class="hf-cart-add__trust">Sichere Bezahlung</p>' +
          '<p class="hf-cart-add__ssl">256-Bit-SSL verschlüsselte Übertragung</p>';
        const knopf = wurzel.querySelector('.cart__checkout-button, [name="checkout"]');
        if (knopf && knopf.parentElement) knopf.parentElement.append(fuss);
        else target.append(fuss);
      }

      hfRabatt(kopf.querySelector('.hf-rabatt'), cart);
      hfVorschlag(kopf.querySelector('.hf-tipp'), cart);

      /* total_price ist der Betrag NACH Automatikrabatt — genau der, auf den
         Shopify die Versandgrenze anwendet. */
      const remaining = HF_FREE_SHIPPING_CENTS - cart.total_price;
      const progress = Math.max(0, Math.min(100, (cart.total_price / HF_FREE_SHIPPING_CENTS) * 100));
      const bar = kopf.querySelector('.hf-shipping');
      const track = kopf.querySelector('.hf-shipping__track');
      if (!bar || !track) return;

      bar.classList.toggle('is-complete', remaining <= 0);
      track.style.display = remaining > 0 ? '' : 'none';
      kopf.querySelector('.hf-shipping__fill').style.width = `${progress}%`;
      kopf.querySelector('.hf-shipping__text').textContent =
        remaining > 0
          ? `Noch ${hfMoney(remaining)} bis zum kostenlosen Versand nach Österreich und Deutschland.`
          : 'Kostenloser Versand nach Österreich und Deutschland erreicht.';
      kopf.querySelector('.hf-cart-add__wert').textContent =
        remaining > 0 ? 'wird im Checkout berechnet' : 'kostenlos (AT/DE)';
    });
  } catch (error) {
    /* Lieber gar keine Angabe als eine falsche — stillschweigend aussteigen. */
  } finally {
    hfCartBusy = false;
    if (hfCartWieder) {
      hfCartWieder = false;
      hfScheduleCart();
    }
  }
};

function hfScheduleCart() {
  window.clearTimeout(hfCartTimer);
  hfCartTimer = window.setTimeout(hfRenderCart, 180);
}

/* Delegiert, weil die Schublade bei jedem Vorgang neu gerendert wird. */
document.addEventListener('click', (e) => {
  const knopf = e.target.closest && e.target.closest('.hf-tipp__add');
  if (!knopf) return;
  const id = Number(knopf.getAttribute('data-id'));
  if (!id) return;
  knopf.disabled = true;

  const korb = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  const last = { items: [{ id: id, quantity: 1 }] };
  if (korb && korb.getSectionsToRender) {
    last.sections = korb.getSectionsToRender().map((s) => s.id);
    last.sections_url = window.location.pathname;
  }
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  fetch(root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
    body: JSON.stringify(last)
  })
    .then((r) => r.json())
    .then((d) => {
      if (d.status) throw new Error(d.description || d.message);
      if (korb && korb.renderContents) korb.renderContents(d);
      hfScheduleCart();
    })
    .catch(() => { knopf.disabled = false; });
});

const hfWatchCart = () => {
  hfFixLeerKlasse();
  hfScheduleCart();

  const observer = new MutationObserver((records) => {
    hfFixLeerKlasse();

    /* Eigene Aenderungen ignorieren, sonst laeuft der Observer im Kreis. */
    const external = records.some((record) => {
      const el = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (!el || !el.closest) return true;
      return !el.closest('.hf-cart-add') && !el.closest('.hf-cart-count');
    });
    if (external) hfScheduleCart();
  });

  [
    document.querySelector('cart-drawer'),
    document.querySelector('#main-cart-items'),
    document.querySelector('#main-cart-footer')
  ]
    .filter(Boolean)
    .forEach((el) => observer.observe(el, { childList: true, subtree: true }));
};

document.addEventListener('DOMContentLoaded', hfWatchCart);
document.addEventListener('shopify:section:load', hfScheduleCart);
